import { css } from 'styled-components';

import {
  VALID_BORDER_DATA,
  VALID_COLOR_DATA,
  VALID_EDGE_STYLE_DATA,
  VALID_OUTLINE_DATA,
  VALID_SHADOW_DATA
} from '../../Utils';
import { VALID_FONT_WEIGHTS, VALID_GLOBAL_FONT_SIZES } from '../../Typography/common';
import { IInputProps } from '../common';

export interface IInputRadioField extends IInputProps {
  value: string;
  hasError?: boolean;
  groupName?: string;
}

export interface IRadioBadgeCommonTheme {
  border: VALID_BORDER_DATA;
  font: {
    color: VALID_COLOR_DATA;
    lineHeight?: string;
    weight?: VALID_FONT_WEIGHTS;
    size?: VALID_GLOBAL_FONT_SIZES;
  };
  backgroundColor: VALID_COLOR_DATA;
  shadow?: VALID_SHADOW_DATA;
  outline?: VALID_OUTLINE_DATA;
  padding?: VALID_EDGE_STYLE_DATA;
}

export interface IRadioButtonCommonTheme {
  backgroundColor?: VALID_COLOR_DATA;
  border: VALID_BORDER_DATA;
  label?: {
    font: {
      color?: VALID_COLOR_DATA;
      lineHeight?: string;
      size?: VALID_GLOBAL_FONT_SIZES;
    };
    margin?: VALID_EDGE_STYLE_DATA;
    padding?: { top?: string; bottom?: string };
  };
  shadow?: VALID_SHADOW_DATA;
}

export interface IRadioCardCommonTheme {
  border: VALID_BORDER_DATA;
  backgroundColor: VALID_COLOR_DATA;
  shadow?: VALID_SHADOW_DATA;
  outline?: VALID_OUTLINE_DATA;
}

interface IRadioButtonCheckedStyleRing {
  checkedStyle: 'ring';
}

interface IRadioButtonCheckedStyleSolid {
  checkedStyle: 'solid';
  checkedBgColor: VALID_COLOR_DATA;
}

export type RadioButtonCheckedStyles = IRadioButtonCheckedStyleRing | IRadioButtonCheckedStyleSolid;

export const sharedRadioInputStyles = css`
  position: absolute;
  opacity: 0;

  ${({ theme: { themeTwo }}) => css`
    z-index: ${themeTwo.global.zIndex.lower};
  `}
`;

export const sharedLabelStyles = css`
  cursor: pointer;
  display: block;
  height: 100%;
  transition: all .1s ease-out;
  width: 100%;
`;
